"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
   mutation setCalorieBudgets($subscriptionPeriodId: Int!, $secure: Boolean!, $budgets: [BudgetForDayType]!) {
    adjustCalorieBudget (
      subscriptionPeriodId: $subscriptionPeriodId, 
      secure: $secure, 
      budgets: $budgets,
    ) {
      success
    }
  }
`;
//# sourceMappingURL=setCalorieBudgets.js.map